import $ from 'jquery';

let handleUSPClick = true;
const handleUSPLinkScroll = () => {
  $(document).on('click', '.usp-link', (event) => {
    if (handleUSPClick) {
      handleUSPClick = false;
      const clickedItem = event.currentTarget;
      const headingThree = document.querySelector('#headingThree button');
      const collapseThree = document.querySelector('#collapseThree');
      if (headingThree && collapseThree) {
        if (!collapseThree.classList.contains('show')) {
          headingThree.click();
        }
      }
      let scrollElement = '#headingThree';
      const returnBlock = document.querySelector('.return_block');
      if (returnBlock && clickedItem.classList.contains('return-link')) {
        scrollElement = '.return_block';
      }
      if (!collapseThree.classList.contains('product-detail__delivery__pane')) {
        setTimeout(() => {
          if ($('.primary-images').height() > $('.product-detail__details-section').height()) {
            document.querySelector('.primary-images').scrollIntoView({ block: 'center' });
          }
          setTimeout(() => {
            // eslint-disable-next-line jquery/no-animate
            $('html,body').animate({
              scrollTop: $(scrollElement).offset().top - $('.header-sticky').height(),
            },
            200);
          }, 300);
        }, 200);
      }
      handleUSPClick = true;
    }
  });
};

export default () => {
  handleUSPLinkScroll();
};
